import React from 'react';
import { magenta } from 'globals/colors';

interface FsMinusInCircleIconProps {
  color?: string;
  className?: string;
}

const FsMinusInCircleIcon: React.FC<FsMinusInCircleIconProps> = ({
  color = magenta.BRAND,
  className,
}) => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5 17C13.1944 17 17 13.1944 17 8.5C17 3.80558 13.1944 0 8.5 0C3.80558 0 0 3.80558 0 8.5C0 13.1944 3.80558 17 8.5 17Z"
        fill={color}
      />
      <path d="M11 9V8H6V9H11Z" fill="white" />
    </svg>
  );
};

export default FsMinusInCircleIcon;
